import { observer } from "mobx-react";
import type React from "react";
import { useEffect } from "react";

import { useProfile } from "hooks/useProfile";

import noOwnedlandingPageImg from "assets/images/no-owned-landing.png";

import { NoOwnedBanner, NoOwnedTextContent } from "./components";

import { StyledContainer, StyledImage } from "./NoLicensePage.styled";

export const NoLicensePage: React.FC = observer(() => {
  const { fetchUserDetails, userDetails } = useProfile();

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  return (
    <StyledContainer data-cy="student-landing-no-owned-products">
      <NoOwnedBanner userDetails={userDetails} />
      <StyledImage alt="" data-cy="noOwned-landing-image" src={noOwnedlandingPageImg} />
      <NoOwnedTextContent />
    </StyledContainer>
  );
});
